import theme from "@/theme";

export const LikeSvg = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11 5.23541C11.6316 4.49658 12.7242 3.66699 14.388 3.66699C17.2984 3.66699 19.25 6.39866 19.25 8.94241C19.25 14.26 12.6298 18.3337 11 18.3337C9.37017 18.3337 2.75 14.26 2.75 8.94241C2.75 6.39866 4.70158 3.66699 7.612 3.66699C9.27575 3.66699 10.3684 4.49658 11 5.23541Z"
      fill={theme.palette.custom.mainBlue}
    />
  </svg>
);

export const UnLikeSvg = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11 5.23541C11.6316 4.49658 12.7243 3.66699 14.388 3.66699C17.2984 3.66699 19.25 6.39866 19.25 8.94241C19.25 14.26 12.6298 18.3337 11 18.3337C9.37017 18.3337 2.75 14.26 2.75 8.94241C2.75 6.39866 4.70158 3.66699 7.612 3.66699C9.27575 3.66699 10.3684 4.49658 11 5.23541Z"
      stroke="#2A2D31"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
